import { RedoCarrierName } from "@redotech/redo-model/carrier-account/carrier-account";

export function getFilteredCarrierOptions({
  carrierOptions,
  checkoutOptimizationEnabled = false,
  newOmsEnabled = false,
}: {
  carrierOptions: RedoCarrierName[];
  checkoutOptimizationEnabled?: boolean;
  newOmsEnabled?: boolean;
}): RedoCarrierName[] {
  const filteredForOms = carrierOptions.filter(
    (carrier) =>
      carrier !== RedoCarrierName.USPS && carrier !== RedoCarrierName.USPS_SHIP,
  );
  const filteredForReturns = carrierOptions.filter(
    (carrier) => carrier !== RedoCarrierName.USPS_DIRECT,
  );

  const filtered = (
    newOmsEnabled || checkoutOptimizationEnabled
      ? filteredForOms
      : filteredForReturns
  ).filter(
    // Sendcloud BYOA onboarding form lands in a follow-up PR; the enum is
    // wired through the backend already, so hide the card until then.
    (carrier) => carrier !== RedoCarrierName.SENDCLOUD,
  );

  return filtered.sort((a, b) => a.localeCompare(b));
}
